<div ngbDropdown [class]="class" #dropdownInstance="ngbDropdown">
  <button
    ngbDropdownToggle
    #button
    aria-haspopup="true"
    [class]="buttonClass"
    [attr.id]="button_id"
    [attr.aria-controls]="menu_id"
    [attr.aria-label]="ariaLabel"
    [disabled]="menuDisabled()"
  >
    <ng-container *ngTemplateOutlet="menuButtonTemplateRef; context: { label }" />
    @if (!menuButtonTemplateRef) {
      {{ label }}
    }
  </button>
  <div
    #menu
    ngbDropdownMenu
    [attr.id]="menu_id"
    role="menu"
    [attr.aria-labelledby]="button_id"
    [class]="menuClass ?? ''"
  >
    @for (link of links; track link; let i = $index) {
      <a
        ngbDropdownItem
        role="menuitem"
        [disabled]="link.disabled ?? false"
        [routerLink]="link.href"
        [class]="menuItemClass ?? ''"
      >
        <ng-container
          [ngTemplateOutlet]="menuItemTemplateRef ?? itemLabel"
          [ngTemplateOutletContext]="{ $implicit: link, index: i }"
        />
      </a>
    }
    @for (action of actions; track action; let i = $index) {
      <div
        ngbDropdownItem
        role="menuitem"
        [disabled]="action.disabled ?? false"
        [class]="menuItemClass ?? ''"
        (click)="action.callback(action)"
      >
        <ng-container
          [ngTemplateOutlet]="menuItemTemplateRef ?? itemLabel"
          [ngTemplateOutletContext]="{ $implicit: action, index: i }"
        />
      </div>
    }
  </div>
</div>

<ng-template #itemLabel let-item>
  {{ item.label }}
</ng-template>
